import { render, staticRenderFns } from "./service-file-upload.vue?vue&type=template&id=36074390&"
import script from "./service-file-upload.vue?vue&type=script&lang=js&"
export * from "./service-file-upload.vue?vue&type=script&lang=js&"
import style0 from "./service-file-upload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports